import React from 'react';
import styles from './styles.module.scss';
import {Flex, Text} from '@priority-software/priority-style-react';
import {PartsDetails} from '../../types';

interface Props {
    part: PartsDetails;
}
const Description = ({part}: Props) => {
    const {description, ePartdescription} = part;
    return (
        <Flex
            componentClasses={styles.descriptionContainer}
            justifyContent="flex-start"
            alignItems="center"
        >
            <Text textColor="primary-700" skin="subtitle-1">
                {description}
            </Text>
            {ePartdescription && (
                <>
                    <Text textColor="secondary-400" skin="subtitle-1">
                        •
                    </Text>
                    <Text textColor="primary-700" skin="label-1">
                        {ePartdescription}
                    </Text>
                </>
            )}
        </Flex>
    );
};

export default Description;
